import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const IIIF_BASE = process.env.REACT_APP_IIIF_BASE;

/**
 * Build a NAS IIIF image URL from an external_id.
 * @param {string} externalId - The 7-digit Leiden image ID
 * @param {number} pct - Percentage size (e.g. 2, 4, 30, 50)
 * @returns {string} Full IIIF URL
 */
export function iiifUrl(externalId, pct = 50) {
  if (!externalId) return null;
  const encoded = encodeURIComponent(externalId + '.jpg');
  return `${IIIF_BASE}/${encoded}/full/pct:${pct}/0/default.jpg`;
}

/**
 * Convert an existing Leiden IIIF URL to use the NAS IIIF server.
 * Handles URLs like: https://iiif.universiteitleiden.nl/iiif/2/hdl:1887.1%252Fitem:3437530/full/pct:50/0/default.jpg
 * @param {string} url - Original image URL
 * @param {number|null} newPct - Optional new percentage (overrides existing)
 * @returns {string} Converted URL pointing to NAS
 */
export function convertImageUrl(url, newPct = null) {
  if (!url) return url;

  // Extract external_id from Leiden URL pattern
  const leidenMatch = url.match(/item[:%](\d{7})/);
  if (leidenMatch) {
    const externalId = leidenMatch[1];
    const pctMatch = url.match(/pct:(\d+)/);
    const pct = newPct || (pctMatch ? parseInt(pctMatch[1]) : 50);
    return iiifUrl(externalId, pct);
  }

  // If not a Leiden URL but has pct: and we want to change it
  if (newPct && url.includes('pct:')) {
    return url.replace(/pct:\d+/, `pct:${newPct}`);
  }

  return url;
}
